<template>
  <div
    class="sub-banner"
    v-if="middleList.length>0"
    :style="{
            backgroundImage: `url(${middleList[0].imageUrl})`,
            width:width,
            height:height
          }"
    @click="goto(middleList[0].route)"
  ></div>
</template>

<script>
import { getAdvertisements } from '@/api/index'
export default {
  name: 'EveryBanner',
  data() {
    return {
      middleList: []
    }
  },
  props: {
    codes: {
      type: String,
      required: true
    },
    width: {
      type: String,
      required: false
    },
    height: {
      type: String,
      required: false
    }
  },
  computed: {},
  created() {
    this.getAdvert()
  },
  methods: {
    async getAdvert() {
      const detail = await getAdvertisements(this.codes)
      if (detail.length > 0) {
        this.middleList = detail[0].list
      }
    },
    goto(router) {
      const find = router.indexOf('http')
      if (find !== -1) {
        location.href = router
      } else {
        this.$router.push(router)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.sub-banner {
  width: 1200px;
  height: 100px;
  background-repeat: no-repeat;
  background-size: cover;
  cursor: pointer;
}
</style>
